ClickElseWhereMixin = require 'mixins/click-else-where'


###
# Кнопка с попоовером
###
App.AddTagButtonComponent = Em.Component.extend ClickElseWhereMixin,
  classNames: ['add-tag-button']
  # Свойства
  searchQuery: ''
  currentIndex: -1

  isAddNewSelected: (->
    @get('currentIndex') == @get('availableTags').length
  ).property('currentIndex', 'availableTags')

  searchQueryIsNotEmpty: (->
    @get('searchQuery').length > 0
  ).property('searchQuery')


  showAddNewTag: (->
    query = @get('searchQuery')
    tags  = @get('allTags')
    tagWasNotAdded = tags.every((tag) => query.trim().toLowerCase() != tag.get('name').trim().toLowerCase())

    @get('searchQueryIsNotEmpty') and tagWasNotAdded
  ).property('searchQueryIsNotEmpty', 'searchQuery', 'availableTags.[]', 'selectedTags')


  availableTags: (->
    query = @get('searchQuery')
    tags = @get('allTags').filter((tag) => not @get('selectedTags').contains(tag))

    if query.length > 0
      tags = tags.filter((tag) => tag.get('name').toLowerCase().lastIndexOf(query.toLowerCase(), 0) == 0)

    tags
  ).property('allTags.[]', 'selectedTags.[]', 'searchQuery')

  onAvailableTagsChange: (->
    @set('currentIndex', -1)
  ).observes('availableTags.[]')

  # Функции
  onClickElsewhere: ->
    @set('isOpen', false)

  didInsertElement: ->
    @$('.sm-text-field').on('input', @onInputChange.bind(@))
    @on('keyDown', @, @interpretKeyEvents)

  willDestroyElement: ->
    @$('.sm-text-field').off('input', @onInputChange.bind(@))

  onInputChange: ->
    @set('searchQuery', @$('.sm-text-field').val().trim())


  # Стрелки
  interpretKeyEvents: (event) ->
    map =
      38: 'arrowUp'
      40: 'arrowDown'
      13: 'enterKey'

    method = map[event.keyCode]
    if method
      this[method](event)
    else
      @_super(event)

  arrowUp: (event) ->
    if @get('currentIndex') != 0
      @set('currentIndex', @get('currentIndex') - 1)

  arrowDown: (event) ->
    if @get('currentIndex') < @get('availableTags').length - 1 or
       @get('currentIndex') == @get('availableTags').length - 1 and @get('showAddNewTag')

      @set('currentIndex', @get('currentIndex') + 1)

  enterKey: (event) ->
    return if @get('currentIndex') == -1

    if @get('isAddNewSelected')
      @send('onAddAndCreateTag')
    else
      @send('onAddClientTag', @get('availableTags').get(@get('currentIndex')))

  # События
  actions:
    openDropdown: ->
      @set('isOpen', true)
      Em.run.next(=> @$('.sm-text-field').focus())

    onAddClientTag: (clientTag) ->
      @set('isOpen', false)
      @sendAction('onAddClientTag', clientTag)

    onAddAndCreateTag: ->
      @set('isOpen', false)
      @sendAction('onAddAndCreateTag', @get('searchQuery'))



###
# Подсказка
###
App.TagSuggestionComponent = Em.Component.extend
  classNames: ['tag-suggestion']
  classNameBindings: ['isSelected']

  isSelected: (->
    @get('index') == @get('selectedIndex')
  ).property('index', 'selectedIndex')

  click: ->
    @sendAction('onTagClicked', @get('clientTag'))